import { ColumnViewModel } from '../../shared/column-types';

export const CHEMICALS_ALL: ColumnViewModel = {
  columns: [
    'chemID',
    'chemPrefName',
    'chemMoleculeType',
    'chemNumGDAs',
    'chemNumPublicationsGDAs',
    'chemNumVDAs',
    'chemNumPublicationsVDAs',
    'chemNumPublications',
    'numCTs',
    'chembl',
    'chebi',
    'pubchem',
    'drugbank',
    'mesh',
  ],
  defaultVisible: [
    'chemPrefName',
    'chemMoleculeType',
    'chemNumGDAs',
    'chemNumPublicationsGDAs',
    'chemNumVDAs',
    'chemNumPublicationsVDAs',
  ],
};